import $ from 'jquery'
require('jquery-match-height')

$(document).ready(function() {
	// JS back button
	$('#back-button').on('click', function() {
		if (
			document.referrer &&
			window.location.hostname === document.referrer.split('/')[2] &&
			window.history.length > 1
		) {
			window.history.back()
		} else {
			window.location.href = '/'
		}
	})

	//matchHeight
	$('.wp-block-column .wp-block-image img').matchHeight()
	//Accodion
	$('.a-title').on('click', function() {
		$(this).toggleClass('is-active')
		$(this)
			.siblings('.a-content')
			.slideToggle()
	})
	//Links
	$('section.links .link-boxes').each(function() {
		if ($(this).children().length > 3) {
			$(this).slick({
				arrows: true,
				dots: false,
				autoplay: true,
				speed: 800,
				autoplaySpeed: 4000,
				slidesToShow: 3,
				slidesToScroll: 3,

				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
				]
			})
		}
	})
})
